import Datatable from "./Datatable/Datatable.jsx";

const DataTable = ({
  data,
  headers,
  totalRecords,
  currentPage,
  recordsPerPage,
  recordsPerPageOptions,
  onPageChange,
  onRecordsPerPageChange,
  addButtonText,
  addButtonLink = "/add",
  onAddClick,
  pageTitle = "Data",
  exportButton = true,
  exportData,
  serverSide = false,
}) => {
  return (
    <Datatable
      data={data}
      headers={headers}
      totalRecords={totalRecords}
      currentPage={currentPage}
      rowsPerPage={recordsPerPage}
      rowsPerPageOptions={recordsPerPageOptions}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRecordsPerPageChange}
      addButtonText={addButtonText}
      addButtonLink={addButtonLink}
      onAddClick={onAddClick}
      pageTitle={pageTitle}
      showExportButton={exportButton}
      exportData={exportData}
      serverSide={serverSide}
    />
  );
};

export default DataTable;

